import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Project, ShippingOrder } from 'src/app/models';
import { faTimes, faSave } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'update-project-for-cart-items-dialog',
  templateUrl: './update-project-for-cart-items-dialog.component.html',
  styles: [''],
})
export class UpdateProjectForCartItemsDialogComponent implements OnInit {
  public form: FormGroup;
  public faTimes = faTimes;
  public faSave = faSave;
  constructor(
    public dialogRef: MatDialogRef<UpdateProjectForCartItemsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      projects: Project[];
    },
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      projectId: [null, Validators.required],
    });
  }
  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    this.dialogRef.close(this.form.value.projectId);
  }
}
